import { useEffect } from 'react';
import * as asyncStorage from 'loot-core/src/platform/server/asyncStorage';

// This hooks sole purpose is to migrate the local storage data
// this must never be modified, new code must be appended only
export function useMigrator() {
  useEffect(() => {
    async function run() {
      let hadMigration = false;

      // 1. signupData to UserData async storage migration (can be cleared not before 2025 April)
      const signupData = await asyncStorage.getItem('signupData');
      if (signupData) {
        await asyncStorage.removeItem('signupData');
        await asyncStorage.setItem('user-data', signupData);
        hadMigration = true;
      }

      if (hadMigration) {
        window.location.reload();
      }
    }
    run();
  }, []);
}
